import { httpClient } from "@/shared/api/http-client"

import type { AuthGoogleResponse, Claims, SelectOrgResponse } from "../model/types"

export function authGoogle(idToken: string): Promise<AuthGoogleResponse> {
  return httpClient.post<AuthGoogleResponse>("/auth/google", { id_token: idToken })
}

export function fetchMe(): Promise<Claims> {
  return httpClient.get<Claims>("/auth/me")
}

export function selectOrg(orgId: string): Promise<SelectOrgResponse> {
  return httpClient.post<SelectOrgResponse>("/auth/select-org", { org_id: orgId })
}
